module.exports = __webpack_public_path__ + "img/icon-bank.62922848.svg";